import { render, staticRenderFns } from "./ClothesRentalFooter.vue?vue&type=template&id=8ab0c35e&scoped=true&"
import script from "./ClothesRentalFooter.vue?vue&type=script&lang=js&"
export * from "./ClothesRentalFooter.vue?vue&type=script&lang=js&"
import style0 from "./ClothesRentalFooter.vue?vue&type=style&index=0&id=8ab0c35e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab0c35e",
  null
  
)

export default component.exports